$( document ).ready(function() {

  $( ".available-size-grid" ).each(function( index ) {
    var el = $(this),
        datacolor = $(this).attr("data-color"),
        text = $(this).text();
    if(datacolor == text){
      el.hide();
    }
  });

  // NEWSLETTER
  $( "#newsletter-pop-up-close" ).click(function() {
    $( "#subscribe-form-pop-up" ).hide();
    Cookies.set("cookies", "1");
  });
  var galleta = Cookies.get("cookies")
  if (galleta != undefined && galleta != ''){
  } else {
    setTimeout(function(){
      $( "#subscribe-form-pop-up" ).show();
    }, 5000);
  }

  // DETAILS
  $( "#details-trigger" ).click(function() {
    $("#details-content").toggle();
    $("#details-container").toggleClass("noline");
  });

  // HEIGHT VIEWPORT
  const windowHeight = document.documentElement.clientHeight;
  document.documentElement.style.setProperty('--viewport-height', `${windowHeight}px`);
  $( window ).on( "resize", function() {
    // HEIGHT VIEWPORT
    const windowHeight = document.documentElement.clientHeight;
    document.documentElement.style.setProperty('--viewport-height', `${windowHeight}px`);
  });

  // FADE IN/OUT
  window.addEventListener("beforeunload", function () {
    $("body").addClass("fade-out");
  });
  window.addEventListener("pageshow", function() {
    setTimeout(function(){
    	$("body").removeClass("fade-out");
    }, 250);
  }, false);
  setTimeout(function(){
    $("body").removeClass("fade-out");
  }, 500);

  // LAZY LOADING
  var L = [].slice.call(document.querySelectorAll('.lazy'));
  if('IntersectionObserver' in window){
    let o = new IntersectionObserver(function(E, observer){
      E.forEach(function(e){
        if(e.isIntersecting){
          let l = e.target;
          if(l.tagName == 'IMG'){
            setTimeout(function(){
              l.src = l.dataset.src;
            }, 500);
          }
          if(l.tagName == 'VIDEO'){
            var P = l.play();
            if(P !== undefined){
              P.catch(error => {
                l.controls = true;
                l.classList.add('no-autoplay');
              });
            }
          }
          l.classList.remove('lazy');
          o.unobserve(l);
        }
      });
    });
    L.forEach(function(l){
      o.observe(l);
    });
  }

  // ADD/REMOVE ITEM
  setTimeout(function(){
    /*$('.cart-product-quantity').each(function() {
      var elplus = $(this).find('.plus'),
          elminus = $(this).find('.minus'),
          quantity = $(this).find('input').val(),
          quentityDiv = $(this).find('.quantity-wrap');
      quentityDiv.text(quantity);
      $(this).on('click', '.plus', function(e) {
        incrementValue(e);
      });
      $(this).on('click', '.minus', function(e) {
        decrementValue(e);
      });
    });*/
    $(document).on('click',  '.plus', function(e){
        var quantity = $(this).parent().find('input').val(),
          quentityDiv = $(this).parent().find('.quantity-wrap');
        quentityDiv.text(quantity);
        incrementValue(e);
    });  
    $(document).on('click',  '.minus', function(e){
        var quantity = $(this).parent().find('input').val(),
          quentityDiv = $(this).parent().find('.quantity-wrap');
        quentityDiv.text(quantity);
        decrementValue(e);
    });  
  }, 20);
  // UPDATE CART COUNT
  function updateCartCount() {
    jQuery.getJSON('/cart.js', function(cart) {
      let itemscount = cart.item_count;
      var totalmoney = cart.total_price;
      totalmoney = totalmoney.toString().slice(0,-2);
      var len = totalmoney.length;
      var x = totalmoney.substring(0, len-3) + "," + totalmoney.substring(len-3);
      if(len < 4){
        $("#total-price-minicart").text("$" + totalmoney);
      } else {
        $("#total-price-minicart").text("$" + x);
      }
      if(itemscount == 0){
        $("#mini-cart").removeClass("active");
        $("#cart-trigger").addClass("disabled");
      } else {
        $("#cart-trigger").removeClass("disabled");
      }
      $("#cart-trigger-number").text(itemscount);
    });
  }
  // ADD PRODUCT
  function incrementValue(e) {
    e.preventDefault();
    var fieldName = $(e.target).data('field');
    var parent = $(e.target).parent('div');
    var currentVal = parseInt(parent.find('input[name="updates[]"]').val(), 10);
    var id = $(e.target).data('id');
    var maxinv = $(e.target).data("inventory")
    console.log(maxinv);

    if(currentVal >= maxinv) {
      console.log("No more stock");
    } else {
      if (!isNaN(currentVal)) {
        parent.find('input[name="updates[]"]').val(currentVal + 1);
        parent.find('.quantity-wrap').text(currentVal + 1);
        jQuery.post('/cart/change.js', {
          quantity: currentVal + 1,
          id: id
        });
      } else {
        parent.find('input[name="updates[]"]').val(0);
        parent.find('.quantity-wrap').text(0);
        jQuery.post('/cart/change.js', {
          quantity: 0,
          id: id
        });
      }
    }
    
    setTimeout(function(){
      updateCartCount();
    }, 500);
  }
  // REMOVE PRODUCT
  function decrementValue(e) {
    e.preventDefault();
    var fieldName = $(e.target).data('field');
    var parent = $(e.target).parent('div');
    var cartitem = $(e.target).closest(".mini-cart-item");
    var currentVal = parseInt(parent.find('input[name="updates[]"]').val(), 10);
    var id = $(e.target).data('id');
    
    if (!isNaN(currentVal) && currentVal > 1) {
      parent.find('input[name="updates[]"]').val(currentVal - 1);
      parent.find('.quantity-wrap').text(currentVal - 1);
      jQuery.post('/cart/change.js', {
        quantity: currentVal - 1,
        id: id
      });
    } else {
      parent.find('input[name="updates[]"]').val(0);
      parent.find('.quantity-wrap').text(0);
      jQuery.post('/cart/change.js', {
        quantity: 0,
        id: id
      });
      cartitem.remove();
    }
    setTimeout(function(){
      updateCartCount();
    }, 500);
  }

  // TOGGLE MINICART
  $( ".close-cart" ).click(function() {
    $( "#mini-cart" ).removeClass("active");
    $( "#menu-container" ).removeClass("show");
    $( "#cart-trigger" ).removeClass("active");
    $("body").removeClass("black-menu");
    $('#menu-mobile').removeClass('show');
    $("#burger").removeClass("active");
  });
  $( "#cart-trigger" ).click(function() {
    $( "#mini-cart" ).toggleClass("active");
    $( "#menu-container" ).removeClass("show");
    $( "#cart-trigger" ).toggleClass("active");
    $("body").removeClass("black-menu");
    $('#menu-mobile').removeClass('show');
    $("#burger").removeClass("active");
  });
  
  // MENU
  $( "#collection-trigger" ).click(function() {
    $('#menu-container').toggleClass('show');
    $( "#mini-cart" ).removeClass("active");
  });

  // MENU MOBILE
  $( "#burger" ).click(function() {
    $("body").toggleClass("black-menu");
    $('#menu-mobile').toggleClass('show');
    $(this).toggleClass("active");
    $( "#mini-cart" ).removeClass("active");
  });

  // Q+A
  $( ".question" ).click(function() {
    $(this).next().toggle();
    $(this).toggleClass('show');
  });

  // SIZE GUIDE
  $( "#size-guide-trigger" ).click(function() {
    $("#size-guide").toggle();
  });

  // SIZE GUIDE
  $( "#select-size-mobile" ).click(function() {
    $(this).hide();
  });

  // COLLECTION BAR
  $( ".collection-trigger" ).click(function() {
    $(this).next().toggle();
  });
  $( "#collection-filter-mode" ).click(function() {
    $(this).find(".current-mode").toggleClass("small-mode-on").toggleClass("large-mode-on");
    $(".collection-grid").toggleClass("small-grid").toggleClass("large-grid");
  });

  // TAGS
  /*
  $( ".collection-tag" ).click(function() {
    var classtag = $(this).attr("data-tag");
    var el = $(this)
    if(el.is(".active")){
      $(".product").show();
      $(".collection-tag").not(el).removeClass("active");
      el.removeClass("active");
    } else {
      $(".product").not(classtag).hide();
      $(classtag).show();
      $(".collection-tag").not(el).removeClass("active");
      el.addClass("active");
    }
  });
  */

});

